import { render, staticRenderFns } from "./VueTable.vue?vue&type=template&id=3a65f00f&scoped=true&"
import script from "./VueTable.vue?vue&type=script&lang=js&"
export * from "./VueTable.vue?vue&type=script&lang=js&"
import style0 from "./VueTable.vue?vue&type=style&index=0&id=3a65f00f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65f00f",
  null
  
)

export default component.exports